export const ANIMATION = 'move-left';

export const ANIMATION_MODAL = 'scale-up';

export const ANIMATION_BUTTON = 'move-left';

export const ANIMATION_ICON = 'scale-up';

//. for exact match e.g(title.), * for likeness (nam*)
export const KEYS_DISPLAY_NAMES_MAP = [
  'createdAt as Created Date',
  'updatedAt as Last Update',
];

export const NAME_KEYS = [
  'fullName',
  'display',
  'reportTitle',
  'message',
  'assignee',
  'recommendation',
  'firm',
  'evaluator',
  'financialYear',
  'seap',
  'reportType',
  'paymentStatus',
  'billType',
  'title',
  'name',
  'approval',
  'comment',
  'details',
  'description',
  'stage',
  'contactValue',
  'member',
  'user',
  'evaluator',
  'facilitator',
  'value',
  'status',
  'Structure',
  'amount',
  'type',
];

export const STATUS_KEYS = [];

export const ALWAYS_ON_TOP_KEYS = ['user','name','application','discipline'];

export const BASE_KEYS = ['id.', 'uid', 'created', 'updated', 'deleted', 'active'];

export const SENSITIVE_KEYS = ['id', 'uid', 'deleted', 'active','created by','set by'];

export const PERCENTAGE_KEYS = ['score','weight','percent'];

export const USER_ID_KEYS = ['userId','userUid','created by','set by','supervisor','appealed by'];

export const COMMENT_KEYS = ['comment'];

export const FORMAT_THOUSANDS_KEYS = ['price','amount','size','value','number'];

export const ATTACHMENT_KEYS = ['pdf','fileName','path','proofAttachment','evidence','cvAttachment'];

export const requestFieldFew = `
  id
  assignedUsers{id uid}
  requestActions{ action {slug name}}
  currentApprovalConfiguration{
    approvalActions{
      name
      slug
    }
    children{
      users{ uid fullName}
    }
  }
  requestHistoryList{createdAt, updatedAt, comment currentApproval{uid fullName} requestStatus}
`
export const AUTH_REDIRECT_ROUTE = '/mis/dashboard';